<template>
  <div>
    <icon-view
      class="mr-2 mt-3 rounded-circle icon-view-color-text"
      icon="fas fa-address-book mb-1"
      icon-background="white"
      icon-color="#FF7058"
      icon-size="16px"
      title="Información Demográfica"
      :gradient="true"
    />
    <div v-if="!readOnly">      
      <validation-observer ref="demographicForm" class="col-12">
        <div class="row mt-4">
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">
              Centro:
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomCenter"
              rules="required"
            >
              <custom-drop-down
                id="customCenter"
                v-model="model.center"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                :error="errors[0]"
                custom-error-msg="El centro es requerido."
                :options="centers"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">
              Número de Solicitud:
            </span>
            {{ registrationNumber | empty }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">
              Fecha de Nacimiento:
            </span>
            <validation-provider
              v-slot="{ errors }"
              :custom-messages="{
                min_age:
                  'La edad mínima del niño(a) permitida es de 2.05 años.',
                required: 'La fecha de nacimiento es requerida.'
              }"
              name="validationCustomBirthDate"
              rules="required|min_age"
            >
              <custom-date-picker
                v-model="model.birthDate"
                format="dd/MMM./yyyy"
                :class-container="'w-100'"
                :max-date="currentDate"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">
              Género:
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomGender"
              rules="required"
            >
              <custom-drop-down
                id="customGender"
                v-model="model.gender"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                custom-error-msg="El género es requerido."
                :error="errors[0]"
                :options="genders"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">
              Etnicidad:
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomEthnicity"
              rules="required"
            >
              <custom-drop-down
                id="customEthnicity"
                v-model="model.ethnicity"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                custom-error-msg="La etnicidad es requerida."
                :error="errors[0]"
                :options="ethnicities"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">
              Número de Seguro Social:
            </span>
            <custom-input
              id="customSsn"
              v-model="model.ssn"
              placeholder="xxx-xx-xxxx"
              mask-type="Personalssn"
              maxlength="11"
              :disabled="readOnly"
            />
          </div>
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">
              Nombre:
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomFirstName"
              rules="required"
            >
              <custom-input
                id="customFirstName"
                v-model="model.firstName"
                maxlength="100"
                :error="errors[0]"
                custom-error-msg="El nombre es requerido."
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <span class="data-title d-block mb-2">
              Inicial:
            </span>
            <custom-input
              id="customInitial"
              v-model="model.initial"
              maxlength="1"
              :disabled="readOnly"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <span class="data-title d-block mb-2">
              Primer Apellido:
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomLastPaternalName"
              rules="required"
            >
              <custom-input
                id="customLasPaternaltName"
                v-model="model.lastPaternalName"
                custom-error-msg="El primer apellido es requerido."
                maxlength="100"
                :error="errors[0]"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <span class="data-title d-block mb-2">
              Segundo Apellido:
            </span>
            <custom-input
              id="customLasMaternaltName"
              v-model="model.lastMaternalName"
              maxlength="100"
              :disabled="readOnly"
            />
          </div>
        </div>
      </validation-observer>
    </div>
    <div v-else>
      <div class="row mt-4">
        <div class="col-md-3 mb-3">
          <span class="data-title d-block mb-2">
            Centro:
          </span>
          <custom-drop-down
            id="customCenterEdit"
            v-model="model.center"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"                        
            :options="centers"  
            :clearable="false"          
            v-if="canEditCenter"
            @input="$emit('change-center', model.center.id)"
          />
          <span v-else>{{ model.center ? model.center.name : "-" }}</span>          
        </div>
        <div class="col-md-3 mb-3">
          <span class="data-title d-block mb-2">
            Número de Solicitud:
          </span>
          {{ registrationNumber | empty }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 mb-3">
          <span class="data-title d-block mb-2">
            Fecha de Nacimiento:
          </span>
          {{ model.birthDate | date }}
        </div>
        <div class="col-md-3 mb-3">
          <span class="data-title d-block mb-2">
            Género:
          </span>
          {{ model.gender ? model.gender.name : "-" }}
        </div>
        <div class="col-md-6 mb-3">
          <span class="data-title d-block mb-2">
            Etnicidad:
          </span>
          {{ model.ethnicity ? model.ethnicity.name : "-" }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 mb-3">
          <span class="data-title d-block mb-2">
            Nombre:
          </span>
          {{ model.firstName | empty }}
        </div>
        <div class="col-md-3 mb-3">
          <span class="data-title d-block mb-2">
            Inicial:
          </span>
          {{ model.initial | empty }}
        </div>
        <div class="col-md-6 mb-3">
          <span class="data-title d-block mb-2">
            Apellidos:
          </span>
          {{ model.lastPaternalName }} {{ model.lastMaternalName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import CustomDropDown from "custom-drop-down";
import CustomDatePicker from "custom-date-picker";
import CustomInput from "CustomInput";
import IconView from "icon-view";

// Utils
import { extend } from "vee-validate";
import dateUtil from "@/utils/dateUtil.js";

extend("min_age", {
  async validate(value) {
    let age = dateUtil.calculateAge(value);
    if (age > 0) {
      return age >= 2.05;
    }
    return false;
  },
  message: "La edad mínima del niño(a) permitida es de 2.05 años."
});

export default {
  name: "registrationDemographicInformation",
  components: {
    CustomDropDown,
    CustomDatePicker,
    CustomInput,
    IconView
  },
  computed:{
    canEditCenter(){            
      return this.$store.getters.HasPermission('student.partcpartbreferral.changecenter');      
    }
  },
  watch: {
    model: {
      deep: true,
      immediate: true,
      handler(value) {
        this.$emit("input", value);
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler(value) {
        this.model = value;
      }
    }
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        center: null,
        birthDate: null,
        gender: null,
        ethnicity: null,
        ssn: null,
        firstName: null,
        initial: null,
        lastPaternalName: null,
        lastMaternalName: null
      })
    },
    centers: {
      type: Array,
      default: () => []
    },
    genders: {
      type: Array,
      default: () => []
    },
    ethnicities: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean,
      default: () => false
    },
    registrationNumber: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      isEnable: false,
      currentDate: new Date(),
      model: {
        center: null,
        birthDate: null,
        gender: null,
        ethnicity: null,
        ssn: null,
        firstName: null,
        initial: null,
        lastPaternalName: null,
        lastMaternalName: null
      }
    };
  }
};
</script>

<style>
.container-form {
  margin-left: 56px;
}
</style>
